// src/pages/hotelMealPlans/EditHotelMealPlan.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelMealPlan from "../../components/hotelMealPlans/FormAddEditHotelMealPlan";
import useGetHotelMealPlan from "../../hooks/hotelMealPlans/useGetHotelMealPlan";
import { CircularProgress, Box } from "@mui/material";

const EditHotelMealPlan = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, hotelMealPlan } = useGetHotelMealPlan(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelMealPlan
                isEdit={true}
                currentData={hotelMealPlan}
                onSubmitSuccess={() => navigate("/hotel-meal-plans")}
            />
        </WrapperSection>
    );
};

export default EditHotelMealPlan;
